import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {

  constructor() { }
  
  public generatePassword(length: number): string {
    const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*_-+=';
    
    let password = '';
    for (let i = 0; i < length; i++) {
      password += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    
    return password;
  }
  
  public generateUuid(): string {
    const parts: string[] = [];
    for (let i = 0; i < 16; i += 1) {
      // eslint-disable-next-line no-bitwise
      let value = (Math.random() * 256) | 0;
      if (i === 6) {
        // eslint-disable-next-line no-bitwise
        value = (value & 0x0f) | 0x40;
      } else if (i === 8) {
        // eslint-disable-next-line no-bitwise
        value = (value & 0x3f) | 0x80;
      }
      
      parts.push((0x100 + value).toString(16).substring(1));
      if ([3, 5, 7, 9].includes(i)) {
        parts.push('-');
      }
    }
    
    return parts.join('');
  }
}
